const home = {
  heroAlt: "Vakmensen bekijken plannen bij een renovatie",
  galleryAlt: "Bouw- en renovatiesector",
  install: {
    iosSub: "Download in de",
    androidSub: "Ontdek het op",
    iosTitle: "Installeren op iPhone/iPad",
    iosDesc: "Open deze pagina in Safari, tik op Deel en daarna op 'Zet op beginscherm'.",
    androidTitle: "De app installeren",
    androidDesc: "Open het browsermenu en kies 'App installeren' / 'Toevoegen aan startscherm'.",
  },
  apps: {
    nuvliTitle: "NuvliPro mobiele app",
    nuvliDesc: "Offertes, facturen, werven, uitgaven en arbeidstijdregistratie op je gsm.",
    nuvliInstall: "Download NuvliPro",
    nuvliNote: "Rechtstreekse installatie (PWA) · werkt op Android en iPhone, neemt geen ruimte in.",
    workerTitle: "Mobiele app GPS-prikklok",
    workerDesc: "Voor werknemers: in- en uitklokken met gps en aanmelden met een toegangscode.",
    workerInstall: "Download GPS-prikklok",
    workerNote: "Voor werknemers · open na de installatie de app en meld je aan met je toegangscode.",
    workerCta: "Werknemersapp openen",
    qrTitle: "Tijdregistratie met gps",
    qrSubtitle: "Eenvoudig en veilig inklokken voor je team",
    qrText: "Download hem gratis via onze website",
    qrInstall: "Installeren op je gsm",
    qrAvailable: "Beschikbaar voor Android en iPhone",
  },
  login: {
    title: "Aanmelden", email: "E-mail", password: "Wachtwoord", emailPh: "jij@email.com", submit: "Aanmelden",
    forgot: "Wachtwoord vergeten?", register: "Gratis registreren", welcome: "Welkom", error: "Aanmelden mislukt",
  },
  features: {
    badge: "Functies",
    title: "Alles wat je nodig hebt om je zaak te beheren",
    items: [
      { t: "Facturatie", d: "Facturen met automatische nummering, btw en inhoudingen, statussen en professionele pdf-download." },
      { t: "Offertes", d: "Offertes per hoofdstuk en beschrijvende posten; zet ze met één klik om in een factuur." },
      { t: "Uitgavenbeheer", d: "Registreer materiaal, arbeid en leveringen; volg de uitgaven per werf en categorie." },
      { t: "Deelbetalingen", d: "Registreer voorschotten, volg het openstaande saldo op en verstuur automatisch ontvangstbewijzen." },
      { t: "Kwartaalrapporten", d: "Btw en inkomstenbelasting per kwartaal, klaar voor je boekhouder en exporteerbaar naar pdf en Excel." },
      { t: "Klantenbeheer", d: "Volledige fiche per klant, documentgeschiedenis en opsporing van wanbetalers." },
    ],
  },
  pricing: {
    badge: "Formules en prijzen",
    title: "Kies de formule die het best bij je zaak past",
    subtitle: "Begin gratis en zonder einddatum. Upgrade wanneer je meer nodig hebt: geen verplichtingen, opzeggen wanneer je wilt.",
    freeCta: "Gratis account aanmaken",
    labels: { gratuito: "Gratis formule", trimestral: "Kwartaalformule", anual: "Jaarformule" },
    perMonth: "{{amount}}/maand",
    approx: "≈ {{amount}}/maand",
    periodo: { gratuito: "Zonder einddatum", trimestral: "{{total}} per 3 maanden", anual: "{{total}} per jaar" },
    nota: { gratuito: "Starten zonder te betalen", trimestral: "Onbeperkt, betaling per 3 maanden", anual: "Eén betaling per jaar" },
    badges: { trimestral: "Populairst" },
    save: "Je bespaart {{amount}}/jaar",
    features: {
      gratuito: ["Tot 8 klanten", "Tot 8 offertes", "Facturatie en deelbetalingen voor je 8 klanten", "Uitgaven en kwartalen: de laatste 2 kwartalen", "2 bouwprojecten", "Tijdregistratie met onbeperkt aantal werknemers"],
      trimestral: ["Onbeperkt klanten, offertes en projecten", "Volledige geschiedenis van uitgaven en kwartalen", "AI, VeriFactu en bankafstemming", "Herinneringen per e-mail en WhatsApp", "Export voor je boekhouder"],
      anual: ["Alles van de kwartaalformule", "Gepersonaliseerde documenten en logo", "Geplande automatische meldingen", "Voorrang bij ondersteuning"],
    },
    payCard: "Betalen met kaart",
    payNote: "Kaart: automatische verlenging, altijd opzegbaar",
    footnote: "Prijzen exclusief btw · Betaling met kaart · Veilige betaling via Stripe",
    approxNote: "Benaderende tegenwaarde in {{currency}} tegen de wisselkoers van vandaag. Het exacte bedrag zie je op de betaalpagina.",
    payError: "De betaling kon niet worden gestart",
  },
  trust: {
    title: "Vakmensen die NuvliPro al vertrouwen",
    subtitle: "Echte beoordelingen van bedrijven uit de bouw- en renovatiesector.",
    testimonials: [
      { cargo: "Algemeen directeur", empresa: "Constructora MendozaBuild S.A.", texto: "We werkten meer dan tien jaar met Excel en systemen die niet met elkaar communiceerden. Met NuvliPro hebben we alle informatie van onze 8 projecten samengebracht en de administratietijd met 60% verminderd. De rentabiliteitsrapporten per project zijn nu nauwkeurig en ik beslis op basis van echte cijfers, niet op gevoel." },
      { cargo: "Projectdirectrice", empresa: "Grupo Constructor Rojas & Asociados", texto: "We gingen van 3 naar 12 actieve projecten en ons manuele systeem bezweek. Met NuvliPro zijn we gegroeid zonder het administratieve personeel te verdubbelen: volledige traceerbaarheid van elk materiaal, opvolging van onderaannemers in realtime en 75% minder einddocumentatie. Onze klanten krijgen rapporten die vertrouwen wekken." },
      { cargo: "Zelfstandig eigenaar", empresa: "18 jaar in de sector", texto: "Mijn werven werden steeds complexer en minder rendabel, en de kosten liepen weg zonder dat ik wist waar. Met NuvliPro vond ik de financiële lekken, bundelde ik leveranciers en verlaagde ik de algemene kosten met 22% zonder in te boeten aan kwaliteit. Nu maak ik gedetailleerdere offertes in minder tijd en sluit ik meer projecten af." },
    ],
    seals: [
      { t: "AVG-conform", d: "Beschermde gegevens" },
      { t: "SSL-versleuteling", d: "Veilige verbinding" },
      { t: "Betalingen via Stripe", d: "Beschermde betalingen" },
      { t: "Ondersteuning in het Spaans", d: "Wanneer je ze nodig hebt" },
    ],
  },
  demo: {
    badge: "Demovideo",
    title: "Ontdek NuvliPro in 2 minuten",
    subtitle: "Bekijk hoe je een offerte maakt, ze omzet in een factuur en betalingen en uitgaven opvolgt.",
    unsupported: "Je browser ondersteunt het afspelen van video niet.",
    soon: "Demovideo binnenkort beschikbaar",
  },
  faq: {
    badge: "Veelgestelde vragen",
    title: "We beantwoorden je vragen",
    items: [
      { q: "Heb ik boekhoudkennis nodig om NuvliPro te gebruiken?", a: "Nee. NuvliPro is gemaakt voor zelfstandigen en kleine bedrijven: je maakt offertes en facturen door duidelijke velden in te vullen en de app berekent automatisch btw, inhoudingen en totalen." },
      { q: "Kan ik het gratis proberen?", a: "Ja. De gratis formule verloopt niet en vraagt geen kaart: tot 8 klanten, 8 offertes, 8 facturen en 1 actief bouwproject. Heb je meer nodig, stap dan over naar een betaalde formule." },
      { q: "Zijn de gegevens van mijn klanten veilig?", a: "Ja. We versleutelen de verbinding (SSL), we leven de AVG na en betalingen worden veilig afgehandeld via Stripe. We delen je gegevens nooit." },
      { q: "Kan ik mijn facturen en offertes personaliseren met mijn logo?", a: "Ja. Vanuit je persoonlijke ruimte kun je het logo van je bedrijf uploaden en het documentontwerp kiezen dat bij je merk past." },
      { q: "Helpt NuvliPro bij de driemaandelijkse belastingopvolging?", a: "Ja. Het maakt automatisch het overzicht van verschuldigde/aftrekbare btw en inkomstenbelasting per kwartaal, exporteerbaar naar pdf en Excel voor je boekhouder." },
      { q: "Kan ik opzeggen wanneer ik wil?", a: "Natuurlijk. Er zijn geen verplichtingen: je kunt je formule op elk moment wijzigen of opzeggen vanuit je account." },
    ],
  },
  contact: {
    badge: "Contact",
    title: "Zullen we praten?",
    subtitle: "Vertel ons wat je nodig hebt en we antwoorden zo snel mogelijk. We helpen je graag om het maximum uit NuvliPro te halen.",
    support: "Klantendienst",
    supportNote: "Ondersteuning in het Spaans · antwoord binnen 24-48 u",
    name: "Naam", namePh: "Je naam", email: "E-mail", emailPh: "jij@email.com",
    message: "Bericht", messagePh: "Waarmee kunnen we je helpen?", send: "Bericht versturen",
    sent: "Bericht verstuurd! We antwoorden je snel.", error: "Het bericht kon niet worden verstuurd",
  },
  cta: {
    title: "Je hele zaak op één plek",
    items: ["Klanten", "Offertes", "Facturatie", "Deelbetalingen", "Uitgaven", "Kwartaal", "Wanbetalers", "WhatsApp"],
    button: "Maak mijn gratis account aan",
  },
  footer: "Volledig beheer voor professionals in de bouw en renovatie",
};
export default home;
